import React from 'react';

type Props = {
  navigationMenu: string[],
  pageSection: string,
  updateSection: Function,
}

function Navigation({ navigationMenu, pageSection, updateSection } : Props) {
  return (
    <nav className="mb-5 flex flex-nowrap whitespace-nowrap overflow-x-auto mx-[5px] leading-[26px]">
      {navigationMenu.map((section:any) => (
        <button
          key={section}
          type="button"
          onClick={() => updateSection(section)}
          className={`${pageSection === section && 'text-chdGreen-light'} group uppercase mr-5 py-5 hover:text-chdGreen-light tracking-widest`}
        >
          {section}
          <div className={`${pageSection === section && 'bg-chdGreen-light'} mt-1 h-2 w-full group-hover:bg-chdGreen-light rounded-t-sm`} />
        </button>
      ))}
    </nav>
  );
}

export default Navigation;
